module.exports = __webpack_public_path__ + "media/honey-icons/icon-leak-a87416dc.svg";